import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import { DEFAULT_EODP_FR_URL_PARAMETER } from '~/constants/RoutesEnums';
import useIsHome from '~/composables/useIsHome';
import useIsEodp from '~/composables/useIsEodp';
import { getPagePaths, PageTypes } from '~/types/PageTypes';
import { useLocalization } from '~/composables/_next/useLocalization';
import { acceptLanguage } from '~/i18n.config';
var frenchUrl = '/info/fiche-technique';
var defaultUrl = '/product';
export default (function () {
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale,
    defaultLocale = _useLocalization.defaultLocale;
  var route = useRoute();
  var router = useRouter();
  var _useIsHome = useIsHome(),
    isHome = _useIsHome.isHome;
  var _useIsEodp = useIsEodp(),
    isEodp = _useIsEodp.isEodp;
  var getProductPrefix = function getProductPrefix() {
    if (locale === 'fr') {
      return "".concat(frenchUrl);
    } else {
      return "".concat(defaultUrl);
    }
  };
  var getProductSuffix = function getProductSuffix(product) {
    var isEssentialOil = product === null || product === void 0 ? void 0 : product.isEssentialOil;
    if (locale === 'fr') {
      return isEssentialOil ? DEFAULT_EODP_FR_URL_PARAMETER : '';
    } else {
      return '';
    }
  };
  var getProductPath = function getProductPath(product) {
    var _product$product;
    if (!product) return '';
    var slug = product.slug || product._slug || ((_product$product = product.product) === null || _product$product === void 0 ? void 0 : _product$product.url) || product.productSlug || '';
    if (!slug) return '';
    return "".concat(getProductPrefix(), "/").concat(slug).concat(getProductSuffix(product));
  };
  var getDomain = function getDomain() {
    var _window, _window$location;
    return process.env.DOMAIN || process.client && ((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.origin);
  };
  var addTrailingSlash = function addTrailingSlash(path) {
    if (!path.endsWith('/')) {
      return path + '/';
    }
    return path;
  };
  var removeTrailingSlash = function removeTrailingSlash(path) {
    if (path.endsWith('/')) {
      return path.slice(0, -1);
    }
    return path;
  };
  var getCanonicalUrl = function getCanonicalUrl() {
    var path = (route === null || route === void 0 ? void 0 : route.path) || '';
    if (isHome.value && locale === 'fr') {
      return getDomain() + addTrailingSlash(path);
    }
    if (isEodp.value) {
      return getDomain() + removeTrailingSlash(path) + DEFAULT_EODP_FR_URL_PARAMETER;
    }
    if (Number(route === null || route === void 0 ? void 0 : route.query.page) > 1) {
      return getDomain() + removeTrailingSlash(path) + "?page=".concat(route.query.page);
    }
    return getDomain() + removeTrailingSlash(path);
  };
  var getRouterPath = function getRouterPath(url) {
    try {
      var _URL = new URL(url),
        href = _URL.href,
        origin = _URL.origin,
        pathname = _URL.pathname;
      if (origin === window.location.origin) {
        return router.resolve(pathname).route.fullPath;
      } else {
        return href;
      }
    } catch (e) {
      return url;
    }
  };

  /**
   * Build a page path from its type, locale and parameters to replace
   * @param type Type of page
   * @param locale locale to use
   * @param toReplace parameters to replace ({slug: "..."}) to replace in /products/:slug for example
   * @returns string (path)
   */
  var getPagePath = function getPagePath(type, locale, toReplace) {
    var paths = getPagePaths(acceptLanguage, type);
    if (paths !== null && paths !== void 0 && paths[locale]) {
      var path = paths[locale];
      if (toReplace) {
        Object.keys(toReplace).forEach(function (param) {
          return path = path.replace(new RegExp(':' + param, 'g'), toReplace[param]);
        });
      }
      if (locale !== defaultLocale) {
        path = '/' + locale + path;
      }
      return path;
    } else {
      return '/';
    }
  };

  /**
   * Detect the content type of a path
   * @param path path to detect
   */
  var getContentType = function getContentType(path) {
    // Mapping of all paths to their content type
    var pathMappings = Object.entries(PageTypes).reduce(function (acc, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      var paths = getPagePaths(acceptLanguage, value);
      Object.entries(paths).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          lang = _ref4[0],
          path = _ref4[1];
        var fullPath = lang === defaultLocale ? path : "/".concat(lang).concat(path);
        acc[fullPath] = value;
      });
      return acc;
    }, {});
    if (pathMappings[path]) {
      return pathMappings[path];
    }
    for (var _i = 0, _Object$entries = Object.entries(pathMappings); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        pathPattern = _Object$entries$_i[0],
        pageType = _Object$entries$_i[1];
      var regexPattern = new RegExp("^".concat(pathPattern.replace(/:\w+/g, '[^/]+').replace(/\//g, '\\/'), "$"));
      if (regexPattern.test(path)) {
        var _route$query;
        if (pageType === PageTypes.PDP && ((_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.page) === 'library') {
          return PageTypes.EODP;
        }
        return pageType;
      }
    }
    return null;
  };
  return {
    getDomain: getDomain,
    getProductPrefix: getProductPrefix,
    getProductPath: getProductPath,
    getCanonicalUrl: getCanonicalUrl,
    getRouterPath: getRouterPath,
    getPagePath: getPagePath,
    getContentType: getContentType
  };
});